module.exports = __webpack_public_path__ + "static/img/12.3b2118a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurante/12.jpg
// module id = fA7v
// module chunks = 1